<template>
  <article>
    <h1 class="subtitle-2 text--primary mb-2">
      <slot name="title"/>
    </h1>

    <v-divider/>

    <div class="body-2 mt-2">
      <slot/>
    </div>
  </article>
</template>

<script>
export default {
  name: 'CSummarySheet'
}
</script>
